import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "lib/api";
import { useStorefrontTenant } from "context/StorefrontTenantContext";
import { resolveStorefrontAssetUrl } from "lib/storefrontTheme";

/**
 * Tenant home hero from PIM (placement storefront_hero) with company hero URL fallback.
 */
export default function useStorefrontHero(companyKey) {
  const { tenant } = useStorefrontTenant();
  const key = String(companyKey || tenant?.companyKey || tenant?.key || "")
    .trim()
    .toLowerCase();

  const { data, isLoading } = useQuery({
    queryKey: ["storefront-hero", key],
    queryFn: () => get("/api/storefront/homepage-hero"),
    staleTime: 30000,
    enabled: !!key,
  });

  return useMemo(() => {
    const pimUrl = String(data?.data?.imageUrl || "").trim();
    const settingsUrl = resolveStorefrontAssetUrl(tenant?.storefrontHeroImageUrl);
    const imageUrl = pimUrl || settingsUrl || "";
    return {
      imageUrl,
      title: data?.data?.title || "",
      subtitle: data?.data?.subtitle || "",
      source: pimUrl ? "pim" : settingsUrl ? "settings" : null,
      isLoading,
    };
  }, [data, tenant?.storefrontHeroImageUrl, isLoading]);
}
